import { render, staticRenderFns } from "./WootButton.vue?vue&type=template&id=2a8b9db5&scoped=true&"
import script from "./WootButton.vue?vue&type=script&lang=js&"
export * from "./WootButton.vue?vue&type=script&lang=js&"
import style0 from "./WootButton.vue?vue&type=style&index=0&id=2a8b9db5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b9db5",
  null
  
)

export default component.exports